/**
 * Teals Design System - Design Tokens
 *
 * This package exports all design tokens used across the Teals UI components.
 */
export * from './colors';
export * from './typography';
export * from './spacing';
export * from './breakpoints';
export * from './shadows';
export * from './radii';
export * from './transitions';
export * from './zIndices';
// Re-export individual modules as namespaces
import { colors } from './colors';
import { typography, fontFamilies, fontWeights, fontSizes, lineHeights, letterSpacings, textStyles } from './typography';
import { spacing, semanticSpacing } from './spacing';
import { breakpoints, mediaQueries, mediaQueriesMax, containerMaxWidths } from './breakpoints';
import { shadows, focusRings } from './shadows';
import { radii } from './radii';
import { durations, easings, transitions } from './transitions';
import { zIndices } from './zIndices';
/**
 * Complete theme object containing all design tokens.
 * Default theme matches teals-website (assets/css/tealslabs.css).
 * Use this with styled-components ThemeProvider.
 */
export const tealsTheme = {
    colors,
    typography,
    fontFamilies,
    fontWeights,
    fontSizes,
    lineHeights,
    letterSpacings,
    textStyles,
    spacing,
    semanticSpacing,
    breakpoints,
    mediaQueries,
    mediaQueriesMax,
    containerMaxWidths,
    shadows,
    focusRings,
    radii,
    durations,
    easings,
    transitions,
    zIndices,
};
// Default export
export default tealsTheme;
